import auth from "../../middlewares/auth";

export const supportRoutes = [
    {
        path: '/my-inquiry',
        component: () => import(/* webpackChunkName: "services" */ '../../views/inquiry/MyInquiry.vue'),
        name: 'my_inquiry',
        props: true,
        meta: {
            middleware: [
                auth
            ]
        }
    },
    {
        path: '/support-chat',
        component: () => import(/* webpackChunkName: "services" */ '../../views/chat/ChatIndex.vue'),
        name: 'support_chat',
        props: true,
        meta: {
            middleware: [
                auth
            ]
        }
    },
]